import styled, { css } from 'styled-components';
import { getAutomatedStyleProp } from '../../../providers/ComponentsThemeProvider';
export const Container = styled.div `
  & + & {
    margin-top: var(--space-200);
  }
`;
export const Main = styled.div `
  display: flex;

  ${({ $bold }) => $bold &&
    css `
      font-weight: ${getAutomatedStyleProp('fontWeightBaseBold', 'var(--font-weight-semibold)')};
    `}

  ${({ $highlighted }) => $highlighted &&
    css `
      color: ${getAutomatedStyleProp('colorOnBackground', 'var(--text-brand)')};
    `}
`;
export const Label = styled.div `
  flex: 1;
`;
export const LabelWithIcon = styled.div `
  flex: 1;
  display: flex;
  align-items: center;
`;
export const IconContainer = styled.div `
  margin-left: var(--space-200);
`;
export const Suggestion = styled.div `
  margin-top: var(--space-50);

  font-size: var(--font-size-300);
  color: var(--text-secondary);
`;
